import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
// src/modules/Scheduling/hooks/useSchedulingUser.ts
var DEFAULT_CACHE_STRATEGY = "cache-only";
function useSchedulingUser(id, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : true;
	const { call, data, isCalling } = useRPC(RPCs.Scheduling.GetSchedulingUser.v1, id ? { id } : void 0, {
		cacheStrategy: opts.cacheStrategy || DEFAULT_CACHE_STRATEGY,
		fire: !!id && fire
	});
	return {
		data: data?.schedulingUser,
		loading: isCalling,
		refresh: call
	};
}
export { useSchedulingUser };

//# sourceMappingURL=useSchedulingUser.js.map